import Udesk from 'Udesk';
import React, { FC, useEffect } from 'react';
import { CreateMdEditorCustomPlugin } from '../CreateMdEditorCustomPlugin';
import MarkdownIt from 'markdown-it';
import MdEditor, { Plugins } from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';

// 初始化Markdown解析器
const mdParser = new MarkdownIt(/* Markdown-it options */);
MdEditor.unuse(Plugins.Image);
MdEditor.unuse(Plugins.Table);
MdEditor.unuse(Plugins.BlockCodeInline);
MdEditor.unuse(Plugins.BlockCodeBlock);
let MdEditorCustomPlugin: any = null;

interface TemplateProps {
    taskType?: any;
    taskTypeList?: any;
    value?: any;
    onChange?: any;
}

const Template: FC<TemplateProps> = (props) => {
    const { taskType, taskTypeList, value, onChange } = props;

    useEffect(() => {
        return () => {
            if (MdEditorCustomPlugin) {
                // 销毁 MdEditorCustomPlugin
                MdEditor.unuse(MdEditorCustomPlugin);
                MdEditorCustomPlugin = null;
            }
        };
    }, []);

    if (taskType && !MdEditorCustomPlugin) {
        // 创建 MdEditorCustomPlugin
        MdEditorCustomPlugin = Udesk.react.udeskify(
            CreateMdEditorCustomPlugin({
                taskType,
                taskTypeList,
            })
        );
        MdEditor.use(MdEditorCustomPlugin);
    }

    return (
        <MdEditor
            style={{ height: '500px' }}
            renderHTML={(text) => mdParser.render(text)}
            onChange={onChange}
            value={value}
        />
    );
};

export default Template;
